import { HttpClient } from "../../../../services/http/http-client";
import { BOOKING_URL, BOOKINGS_STRING, CALENDAR_DATES_STRING } from "../booking-service";

export const CALENDAR_BOOKINGS_ARTISTS_DETAILS_STRING = 'calendar_bookings_artist_details';

export const CALENDAR_DATE_ARTIST_ID = 'calendar_date_artist_id';
export const PERFORMANCE_TIME = 'performance_time';
export const CALENDAR_DATE_ARTISTS = 'calendar_date_artists';

const PERFORMANCE_TYPE = 'performance_type';
const SOUNDCHECK = 'soundcheck';
const PERFORMANCE_TIME_CONTRACT = 'performance_time_contract';
const STAGE_NAME = 'stage_name';

const CALENDAR_DATE_ID = 'calendar_date_id';
const CURFEW = 'curfew';
const DOORS_OPEN = 'doors_open';
const EVENT_URL = 'event_url';
const LINE_UP = 'lineup';
const CONFIRMED_FLAG = 'confirmed_flag';
const CUSTOM_DATA_ID = 'custom_data_id';
const CUSTOM_DATA = 'custom_data';
const DATA = 'data';

export const eventDetailsService = {
  findEventDetailsByCalendarId: (calendarDateId, options) => {
    return HttpClient.get2(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: CALENDAR_BOOKINGS_ARTISTS_DETAILS_STRING,
      calendar_date_id: calendarDateId
    }, options);
  },
  updatePerformanceType: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID,
    calendarDateArtistId,
    PERFORMANCE_TYPE,
    value,
    CALENDAR_DATE_ARTISTS
  ),
  updateSoundcheck: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID,
    calendarDateArtistId,
    SOUNDCHECK,
    value,
    CALENDAR_DATE_ARTISTS
  ),
  updatePerformanceTime: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID, 
    calendarDateArtistId, 
    PERFORMANCE_TIME, 
    value, 
    CALENDAR_DATE_ARTISTS),
  updateDuration: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID,
    calendarDateArtistId,
    PERFORMANCE_TIME_CONTRACT,
    value,
    CALENDAR_DATE_ARTISTS
  ),
  updateStage: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID,
    calendarDateArtistId,
    STAGE_NAME,
    value,
    CALENDAR_DATE_ARTISTS
  ),
  updateConfirmed: (
    calendarDateArtistId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ARTIST_ID,
    calendarDateArtistId,
    CONFIRMED_FLAG,
    value,
    CALENDAR_DATE_ARTISTS
  ),

  updateDoorsOpen: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    DOORS_OPEN,
    value,
    CALENDAR_DATES_STRING
  ),

  updateCurfew: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    CURFEW,
    value,
    CALENDAR_DATES_STRING,
  ),

  updateEventUrl: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    EVENT_URL,
    value,
    CALENDAR_DATES_STRING,
  ),

  updateLineUp: (
    calendarDateId,
    value
  ) => HttpClient.modify(
    CALENDAR_DATE_ID,
    calendarDateId,
    LINE_UP,
    value,
    CALENDAR_DATES_STRING
  ),

  updateCustomData: (
    customDataId,
    value,
  ) => HttpClient.modify(
    CUSTOM_DATA_ID,
    customDataId,
    DATA,
    value,
    CUSTOM_DATA
  )
};
